import React from "react";
import { useContext, useState, useEffect } from "react";
import { BookContext } from "../context/BookContext";

import "../index.css";
import {
  MDBContainer,
  MDBInput,
  MDBBtn,
  MDBRow,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText,
  MDBCol,
} from "mdbreact";
import ReactLoading from "react-loading";
const ShowDetails = (props) => {
  const {
    getDetails,
    details,
    markRead,
    Loading,
    unLend,
    getLentDetails,
    lentDetails,
  } = useContext(BookContext);
 
  const [Checked, setChecked] = useState(false);
  useEffect(() => {
    getDetails(props.match.params.bookId);
    getLentDetails(props.match.params.bookId);
  }, [props.match.params.bookId]);
  const handleOnChange = (e) => {
    setChecked(true);
    console.log(e.target.value);
    markRead(props.match.params.bookId);
  };
  const handleUnLend = (e) => {
    unLend(props.match.params.bookId);
  };

  return (
    <div>
      <MDBRow>
        <MDBCol md="4"></MDBCol>
        <MDBCol md="4">
          {Loading === true || details === null ? (
            <ReactLoading type="bubbles" color="#c51162" height={500} width={500} />
          ) : (
            <div>
              <MDBCard
                style={{
                  width: "100%",
                  marginTop: "5rem",
                  boxShadow: "8px 8px 15px  rgb(176, 177, 175)",
                  display: "flex",
                  flexDirection: "column",
                  backGroundColor: "#E0E0E0",
                }}
              >
                <MDBCardBody>
                  <MDBCardTitle>
                    <div style={{
                      display:"flex",
                      flexDirection:"row",
                      justifyContent:"space-between",
                      alignItems : "center"
                    }}>
                      <span> Name: {details.name}</span>
                      {Loading == true ? (
                        <ReactLoading
                          type="cylon"
                          color="blue"
                          height={500}
                          width={500}
                        />
                      ) : Checked === false && details.read === false ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            alignItems: "censter",
                          }}
                        >
                          <input
                            type="checkbox"
                            label="unread"
                            onChange={handleOnChange}
                            style={{ marginRight: "10px" }}
                          />
                          <span style={{
                            fontSize:"15px"
                          }}>
                            <b>Read ??</b>
                          </span>
                        </div>
                      ) : (
                        <h4
                          style={{
                            color: "green",
                            fontSize:"15px"

                          }}
                        >
                          Read
                        </h4>
                      )}
                    </div>
                  </MDBCardTitle>
                  <MDBCardText>
                    <b>Author :</b> {details.author}
                  </MDBCardText>
                  <MDBCardText>
                    <b>Price :</b>Rs {details.price} 
                  </MDBCardText>
                  <MDBCardText>
                    <b>Read on:</b> {details.date}{" "}
                  </MDBCardText>
                  <MDBCardText>
                    {" "}
                    {details.lent == "true" ? (
                      <div style={{
                        display : "flex",
                        justifyContent: "space-between"
                      }}>
                        {" "}
                        <div style={{
                          display:"flex",
                          flexDirection : "column",

                        }}>
                        <h6><b>Lent to :</b> {lentDetails.name}</h6>
                        <h6><b>Lent on :</b> {lentDetails.date}</h6>

                        </div>
                        <MDBBtn size="sm" className="UnlendBtn"  onClick={handleUnLend}>
                          Unlend
                        </MDBBtn>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </div>
          )}
        </MDBCol>
        <MDBCol md="4"></MDBCol>
      </MDBRow>
    </div>
  );
};
export default ShowDetails;
